import React from 'react';
import {withStyles} from '@material-ui/core/styles';
import Introduction from '../Content/Introduction';
import Stocks from '../Content/Stocks';
import WhyCryptX from '../Content/WhyCryptX';
import Features from '../Content/Features';
import Investments from '../Content/Investments';
import Payments from '../Content/Payments';
import Commerce from '../Content/Commerce';
import TryDemo from '../Content/TryDemo';
import ApplicationLinks from '../Content/ApplicationLinks';
import Blockchain from '../Content/Blockchain';
import ScalabilityAndTeam from '../Content/ScalabilityAndTeam';

const styles = theme => ({});

export const Content = withStyles(styles)(({classes}) => {

  return (<div>
    <Introduction/>
    <Stocks/>
    <WhyCryptX/>
    <Features/>
    <Investments/>
    <Payments/>
    <Commerce/>
    <TryDemo/>
    <Blockchain/>
    <TryDemo/>
    <ScalabilityAndTeam/>
    <ApplicationLinks/>
  </div>)
});
